import { Button, Typography, Grid, Paper, InputLabel } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useState } from "react";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import SendIcon from "@material-ui/icons/Send";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: "13px 22px 24px 24px !important",
    borderRadius: "25px !important",
    marginLeft: "11px",
    backgroundColor: "rgba(245, 243, 243, 1)",
    border: "8px solid rgba(244, 176, 53, 0.8)",
    width:"81% !important"
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "10px",
  },
  button: {
    marginTop:"10px",
    borderRadius: "11px",
    padding: "4px 37px",
    fontSize: "1rem",
    textTransform: "none",
    // transition: "background-color 0.3s ease",
    // "&:hover": {
    //   backgroundColor: "rgba(12, 77, 162, 1)",
    // },
    backgroundColor: "rgba(12, 77, 162, 1) !important",
    color: "white !important",
    // backgroundColor: isSubmitted ? "grey" : "rgba(12, 77, 162, 1)",
    // color: "white !important",
    // "&:hover": {
    //   backgroundColor:isSubmitted ? "grey" : "rgba(12, 77, 162, 0.8)",
    // },
  },
  sendIcon: {
    marginLeft: theme.spacing(1),
  },
  label: {
    fontSize: "1.1rem !important",
    fontWeight: 600,
    marginBottom: theme.spacing(0.5),
    color: "rgba(12, 77, 162, 1)",
  },
  disabledButton: {
    backgroundColor: "grey !important",
  },
}));

export default function DateRangeste({ generatesteDrflowData }) {
  const classes = useStyles();
  const [isSelected, setIsSelected] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const today = new Date();
  const minDate = new Date();
  minDate.setFullYear(today.getFullYear() - 1);
  const maxDate = today;

  const handleStartDateChange = (date) => {
    if (isDisabled) return;
    if (date === null) {
      setStartDate(null);
      setEndDate(null);
      return;
    }
    const newStartDate = date < minDate ? minDate : date;
    setStartDate(newStartDate);

    const newEndDate = new Date(newStartDate);
    newEndDate.setMonth(newEndDate.getMonth() + 1);
    newEndDate.setDate(newEndDate.getDate() - 1);
    setEndDate(newEndDate > maxDate ? maxDate : newEndDate);
  };

  const handleEndDateChange = (date) => {
    if (isDisabled) return;
    if (date === null) {
      setEndDate(null);
      return;
    }
    const newEndDate = date > maxDate ? maxDate : date;

    const oneMonthAfterStartDate = new Date(startDate || minDate);
    oneMonthAfterStartDate.setMonth(oneMonthAfterStartDate.getMonth() + 1);

    if (newEndDate > oneMonthAfterStartDate) {
      setEndDate(oneMonthAfterStartDate);
    } else {
      setEndDate(newEndDate);
    }
  };

  const sendDateRange = () => {
    if (startDate && endDate && startDate <= endDate) {
      setIsSelected(true);
      setIsDisabled(true);
      
      generatesteDrflowData(
        startDate.toLocaleDateString("en-GB").replace(/\//g, ""),
        endDate.toLocaleDateString("en-GB").replace(/\//g, "")
      );
      setIsSubmitted(true)
    }
  };

  return (
    <Paper
      elevation={3}
      className={classes.paper}
      style={{ width: "74vw", boxShadow: "2px 2px 9px 1px #8e8272" }}
    >
      <Typography variant="h5" gutterBottom></Typography>
      <h4
        style={{
          color: "rgba(12, 77, 162, 1)",
          textAlign: "center",
          fontWeight: "bold",
          fontSize: "18px",
          marginTop: "-10px",
        }}
      >
        Select Date Range
      </h4>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} className={classes.gridItem}>
            <InputLabel className={classes.label}>Start Date</InputLabel>
            <KeyboardDatePicker
              autoOk
              variant="inline"
              inputVariant="outlined"
              format="dd/MM/yyyy"
              disableFuture
              maxDate={maxDate}
              minDate={minDate}
              value={startDate}
              onChange={handleStartDateChange}
              fullWidth
              disabled={isDisabled}
              InputProps={{
                style: {
                  backgroundColor: "white",
                  paddingLeft: "8px",
                },
                inputMode: "numeric",
                pattern: "[0-9]*",
                onKeyPress: (event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                },
              }}
              clearable
              placeholder="dd/mm/yyyy"
              autoFocus
            />
          </Grid>

          <Grid item xs={12} sm={6} className={classes.gridItem}>
            <InputLabel className={classes.label}>End Date</InputLabel>
            <KeyboardDatePicker
              autoOk
              variant="inline"
              inputVariant="outlined"
              format="dd/MM/yyyy"
              disableFuture
              minDate={startDate || minDate}
              maxDate={maxDate}
              value={endDate}
              onChange={handleEndDateChange}
              fullWidth
              disabled={isDisabled}
              InputProps={{
                style: {
                  backgroundColor: "white",
                  paddingLeft: "8px",
                },
                inputMode: "numeric",
                pattern: "[0-9]*",
                onKeyPress: (event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                },
              }}
              clearable
              placeholder="dd/mm/yyyy"
            />
          </Grid>
        </Grid>
      </MuiPickersUtilsProvider>

      <div className={classes.buttonContainer}>
        <Button
          variant="contained"
          color="primary"
          // className={classes.button}
          className={`${classes.button} ${isSubmitted && classes.disabledButton}`}
          disabled={isDisabled}
          onClick={sendDateRange}
          style={{backgroundColor:isSubmitted?" grey !important":"rgba(12, 77, 162, 1)!important"}}
        >
          Send
          <SendIcon className={classes.sendIcon} />
        </Button>
      </div>
    </Paper>
  );
}
